import { createGlobalStyle } from 'styled-components';

const GlobalAppStyle = createGlobalStyle`
    .App {
    color: #000;
    font-family: 'Open Sans';
    src: url(../../fonts/OpenSans-Regular.ttf);
  }

  .preview-container {
    z-index: 100000000;
  }

  .App label {
    color: #8c8c8c;
    font-size: 12px;
    display: block;
    margin: 0px 0 6px 0;
    font-weight: normal;
  }

  span[neb-property-type='mobileIOS'] {
    background: url('//nebula.kampyle.com/assets/images/kampyle/ios_fullscreen.png')
      0px 43px/385px 760px no-repeat;
    height: 804px;
    position: absolute;
    width: 392px;
    top: 0;
    left: 768px;
  }

  span[neb-property-type='mobileAndroid'] {
    background: url('//nebula.kampyle.com/assets/images/kampyle/android_fullscreen.png')
      2px 5px/371px 724px no-repeat;
    height: 804px;
    position: absolute;
    width: 392px;
    top: 49px;
    left: 774px;
  }

  .dig-section-break {
      height: 0px;
      border-top: 1px solid #d9d9d9;
      width: 100%;
      display: block;
      margin: 20px 0 20px 0;
  }
`;

export default GlobalAppStyle;
